export default {
  baseErrorMessges: {
    required: "Dieses Feld ist erforderlich",
    dataType: "Dieses Feld hat nicht den richtigen Typ.",
    existingAsset: "Ein Asset mit dieser Kennung existiert bereits.",
    serialNoIsReq: "Kennung ist erforderlich.",
    length: "Der Wert dieses Feldes muss sein",
    min: "min",
    max: "max",
    maxLength: "Die maximale Anzahl verfügbarer Zeichen für dieses Feld wurde überschritten!",
    onlyNumbersOptionalCommaOrDot:
      "Bitte beachten Sie das gewünschte Format. In diesem Feld sind nur Zahlen und Dezimalstellen erlaubt (es sollte standardmäßig auf zwei Dezimalstellen gerundet werden)!",
    onlyIntegers: "Bitte geben Sie das gewünschte Format an. In diesem Feld sind nur ganze Zahlen erlaubt!",
    lettersNumbersOnly:
      "Bitte geben Sie das gewünschte Format ein. In diesem Feld sind nur Zahlen, Buchstaben und Sonderzeichen erlaubt!",
    guid: "Bitte passen Sie das gewünschte Format für die GUID an. Erlaubt sind Zahlen, Buchstaben von a-f und Bindestriche wie in diesem Beispiel: 51d52cf1-83c9-4f02-b117-703ecb728b74",
  },
};
